/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import deferToClientSideRender from 'js/lib/deferToClientSideRender';

import { Typography2 } from '@coursera/cds-core';

import CourseraPlusNotificationBanner from 'bundles/coursera-plus/components/lihp/CourseraPlusNotificationBanner';
import { useNotificationBannersHandler } from 'bundles/coursera-plus/utils/useNotificationBannersHandler';

import _t from 'i18n!nls/coursera-plus';

const CourseraPlusWelcomeNotification = () => {
  /*
  Show the Coursera Plus welcome notification banner only if:
  - The learner has an active Coursera Plus subscription.
  - The 'isCourseraPlusSuccess' parameter is true in the URL.
  - The learner is not eligible for reactivation of a non-Coursera Plus subscription.
*/
  const { cplusWelcomeNotificationBannerData } = useNotificationBannersHandler();

  if (!cplusWelcomeNotificationBannerData.showBanner) {
    return null;
  }

  const content = (
    <>
      <Typography2 component="h2" variant="subtitleMedium">
        {_t('Congrats on your new Coursera Plus subscription!')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary">
        {_t('Explore all the content included in your subscription to reach your learning goal.')}
      </Typography2>
    </>
  );

  return (
    <CourseraPlusNotificationBanner content={content} storageKey={cplusWelcomeNotificationBannerData.storageKey} />
  );
};

export default deferToClientSideRender(CourseraPlusWelcomeNotification);
